import { useCurrentEditor } from '@tiptap/react';
import React, { useEffect } from 'react';

import GrammarCheckerBubble from './plugins/language-tool/GrammarCheckerBubble';
import GrammarCheckerLoading from './plugins/language-tool/GrammarCheckerLoading';
import { getLanguage } from './plugins/language-tool';

type GrammarCheckerProps = {
  language?: string;
};

function GrammarChecker(_props: GrammarCheckerProps) {
  const { editor } = useCurrentEditor();

  const pluginLanguage = 'English';

  useEffect(
    function updateLanguage() {
      if (!editor || !pluginLanguage) return;

      editor.commands.setLanguage(getLanguage(pluginLanguage));
    },
    [editor, pluginLanguage],
  );

  useEffect(
    function updateActive() {
      if (!editor) return;

      editor.commands.toggleLanguageTool(true);
    },
    [editor],
  );

  return (
    <>
      <GrammarCheckerBubble />
      <GrammarCheckerLoading />
    </>
  );
}

export default React.memo(GrammarChecker);
